<div class="mt-5">
    <div class="table-responsive" v-if="!loading">
        <table class="table table-hover table-bordered mb-0">
            <thead class="thead-light">
                <tr>
                    <th>#</th>
                    <th>Heartbeat Instance ID</th>
                    <th>Log Text</th>
                    <th>Meta Data</th>
                    <th>Inserted On</th>
                    <th>Component</th>
                    <th>Heartbeat Status Code</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="heartbeat in heartbeatLogs">
                    <td>{{heartbeat.heartbeatLogId}}</td>
                    <td>{{heartbeat.heartbeatInstanceId}}</td>
                    <td>{{heartbeat.logText}}</td>
                    <td>{{heartbeat.metaData}}</td>
                    <td>{{heartbeat.insertedOn}}</td>
                    <td>{{heartbeat.component}}</td>
                    <td>{{heartbeat.heartbeatStatusCode}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <loading-spinner :showSpinner="loading"></loading-spinner>
</div>
